export class ElementHelper {
    public static bindListItemsWithHref(element : JQuery<HTMLElement>) {
        element.find('li[data-href]').each((index, labelElement) => {
            var parsedLabelElement = $(labelElement);
            parsedLabelElement.off('click').on('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
    
                var target = parsedLabelElement.data('target');
                var href = parsedLabelElement.data('href');
    
                window.open(encodeURI(href), target);
            })
        });
    }

    public static bindListWithShowMore(element : JQuery<HTMLElement>) {
        element.find('.show-more-list').each((index, showMoreListContainer) => {
            var showMoreList = $(showMoreListContainer);

            showMoreList.on('click', (e) => {
                e.preventDefault();
            })

            var list = showMoreList.children().filter("li");
            var showMore = showMoreList.find(".show-more");
            var showMoreWidth = showMore.width() ?? 0;
            showMore.hide();
    
            var shouldShowShowMore = false;

            var listWidth = showMoreList.width() ?? 0;

            var hiddenItems = 0;
            var currentSetWidth = 0;
            var currentSetRows = 1;

            $.each(list, function(i, item) {
                var listItem = $(item);
                var listItemWidth = listItem.width() ?? 0;

                currentSetWidth += listItemWidth;
                if(currentSetWidth > (listWidth-5)) {
                    currentSetRows++;
                    currentSetWidth = listItemWidth + showMoreWidth;
                }

                if (currentSetRows > 2) {
                    shouldShowShowMore = true;
                    listItem.hide();
                    hiddenItems++;
                } 
            });
            
            if(shouldShowShowMore) {
                showMore.text(`+${hiddenItems}`);
                showMore.show();
            }
            else {
                showMoreList.find('li').last().find('span').remove();
                showMore.remove();
            }
              
            showMore.on('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
    
                showMoreList.find('li').last().find('span').remove();
                showMoreList.children().filter("li").show();
                showMore.remove();
            });
        })
    }

    public static reformatHeightElements(element : JQuery<HTMLElement>) {
        element.find('[class="row"]').each((index, row) => {
            var rowElement = $(row);
            let heights = new Map<string, number>();

            rowElement.find('[class$="element-height"]').each((index, element) => {
                var className = '';
                element.classList.forEach((value, key) => {
                    if(value.endsWith('element-height')) {
                        className = value;
                        return;
                    }
                });
    
                if(heights.has(className)) {
                    return;
                }
    
                var maxHeight = Math.max.apply(null, rowElement.find(`[class="${className}"]`).map(function ()
                {
                    return $(this).height();
                }).get());
    
                heights.set(className, maxHeight);
            });
    
            heights.forEach((value, key) => {
                rowElement.find(`[class="${key}"]`).each((index, element) => {
                    element.style.height = `${value}px`;
                });
            });
        });
    }

    public static reformatCardContentHeight(containerElement : JQuery<HTMLElement>) {
        containerElement.find('.card__content').each((index, element) => {
            var parsedContentElement = $(element);
            var parsedElementHeight = parsedContentElement.innerHeight();
            parsedContentElement.css('height', parsedElementHeight ?? 0);
        })
    }
}


